import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ShowChartIcon from '@mui/icons-material/ShowChart';

export default function CareerTransitionCard(props) {
    const {icon, value, message, isSmallScreen} = props;
  const theme = useTheme();

  return (
    <Card sx={{ display: 'flex', width: "250px", margin:isSmallScreen ? "10px auto auto auto" : "10px 5px auto 5px", 
    borderTop:
    message.includes("Salary Hike") ? "2px solid #D2740D" 
    : message.includes("Career") ? "2px solid green" 
    : message.includes("Hiring") ? "2px solid #7A1074 " 
    : "2px solid #0075c9"
    }}>
          <div style={{margin: "auto", textAlign: "center"}}>
            {message.includes("Salary Hike") &&
            <ShowChartIcon style={{color: "#D2740D", borderRight: "1px solid rgba(0,0,0, 0.08)", padding: "10px"}} fontSize='large'/>
            }
             {message.includes("Career") &&
            <HandshakeIcon style={{color: "green", borderRight: "1px solid rgba(0,0,0, 0.08)", padding: "10px"}} fontSize='large'/>
            }
             {message.includes("Hiring") &&
            <EmojiEventsIcon style={{color: "#7A1074", borderRight: "1px solid rgba(0,0,0, 0.08)", padding: "10px"}} fontSize='large'/>
            }
             {message.includes("Highest Salary") &&
            <AttachMoneyIcon style={{color: "#0075c9", borderRight: "1px solid rgba(0,0,0, 0.08)", padding: "10px"}} fontSize='large'/>
            }
          </div>
          <div style={{margin: "auto", textAlign: "center"}}>
            <b>{value}</b> {message}
          </div>
    </Card>
  );
}